import React, { useMemo } from 'react';
import { useRoute } from '@react-navigation/native';

import MarketSetupDetail from './MarketSetupDetail';
import { GET_MARKET_SETUP, MODIFY_MARKET_SETUP } from '../../../../common/graphql/marketSetup';
import { EmptyState, Screen } from '../../../design/components';
import { useUserContext } from '../../../../common/utils/context';
import { PREDEFINED_USER_ROLES } from '../../../../common/constants';

const MarketSetupDetailView = () => {
	const route = useRoute();
	const { marketSetupId } = route.params || {};
	const { user, isAVC, canCompleteAssignedMarketSetups } = useUserContext();

	const canAccessAllSetups = useMemo(() => user && (
		user.isSuperAdmin || (isAVC && user.role.name === PREDEFINED_USER_ROLES.ADMIN)
	), [user, isAVC]);
	const canAccessAssignedMarketSetups = Boolean(canCompleteAssignedMarketSetups && !user?.isSuperAdmin && !canAccessAllSetups);
	const canAccessSetups = Boolean(canAccessAllSetups || canAccessAssignedMarketSetups);

	if (!canAccessSetups) {
		return (
			<Screen>
				<EmptyState icon="lock" title="You do not have access to this setup." />
			</Screen>
		);
	}

	return (
		<Screen scroll={false}>
			<MarketSetupDetail
				id={marketSetupId}
				query={GET_MARKET_SETUP}
				modifyMutation={MODIFY_MARKET_SETUP}
				isAssignedMarketSetupWorker={canAccessAssignedMarketSetups}
			/>
		</Screen>
	);
};

export default MarketSetupDetailView;
